import * as React from 'react';
import { CircleAlert, RotateCcw } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';

export interface ErrorStateProps {
  /** Текст ошибки — из getErrorMessage(), не сырой ответ API. */
  message: React.ReactNode;
  title?: React.ReactNode;
  onRetry?: () => void;
  retryLabel?: string;
  /** compact — строка внутри карточки вместо крупного блока. */
  compact?: boolean;
  className?: string;
}

/** «Не удалось загрузить» + «Повторить». Не путать с пустым списком (EmptyState). */
export function ErrorState({ message, title, onRetry, retryLabel = 'Повторить', compact, className }: ErrorStateProps) {
  if (compact) {
    return (
      <div role="alert" className={cn('flex flex-wrap items-center gap-2 text-sm text-neg', className)}>
        <CircleAlert className="size-4 shrink-0" aria-hidden />
        <span className="font-semibold">{message}</span>
        {onRetry && (
          <Button variant="link" size="sm" onClick={onRetry}>
            {retryLabel}
          </Button>
        )}
      </div>
    );
  }
  return (
    <div role="alert" className={cn('flex flex-col items-center justify-center gap-3 px-4 py-12 text-center', className)}>
      <div className="grid size-12 place-items-center rounded-2xl bg-neg-soft text-neg">
        <CircleAlert className="size-6" aria-hidden />
      </div>
      {title && <p className="font-display text-base font-bold text-text">{title}</p>}
      <p className="max-w-md text-sm text-text-2">{message}</p>
      {onRetry && (
        <Button variant="secondary" onClick={onRetry}>
          <RotateCcw aria-hidden />
          {retryLabel}
        </Button>
      )}
    </div>
  );
}
